import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { withTheme } from "@material-ui/core/styles";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import LaunchIcon from "@material-ui/icons/Launch";
import React, { Component } from "react";
import { languages } from "../../../constants/languages";
import EditSlideshowContainer from "./EditSlideshowContainer";

class SlideshowsContainer extends Component {
  state = {
    open: false,
    anchorEl: null,
  };

  handleMenu = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  selectSlideshow = (slideshowId) => {
    this.props.selectSlideshow(slideshowId);
    this.handleClose();
  };

  render() {
    return (
      <div>
        <div
          style={{
            whiteSpace: "nowrap",
            overflowX: "auto",
            display: "flex",
            alignItems: "flex-start",
            marginBottom: 10,
          }}
        >
          <Menu
            id="menu-days"
            anchorEl={this.state.anchorEl}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            getContentAnchorEl={null}
            open={Boolean(this.state.anchorEl)}
            onClose={this.handleClose}
          >
            <MenuItem onClick={(e) => this.selectSlideshow("0")}>
              {this.props.tournament.slideshowName ||
                languages.present.slideshow + " 1"}
              <ListItemSecondaryAction>
                <EditSlideshowContainer
                  tournament={this.props.tournament}
                  slideshow={{
                    id: "0",
                    name: this.props.tournament.slideshowName || "",
                  }}
                  dias={[]}
                  selectSlideshow={this.selectSlideshow}
                  selectedSlideshow={this.props.selectedSlideshow}
                />
              </ListItemSecondaryAction>
            </MenuItem>
            {this.props.slideshows
              .sort((a, b) => a.id - b.id)
              .map((slideshow, i) => (
                <MenuItem
                  key={slideshow.id}
                  onClick={(e) => this.selectSlideshow(slideshow.id)}
                >
                  {slideshow.name ||
                    languages.present.slideshow + " " + (i + 2)}
                  <ListItemSecondaryAction>
                    <EditSlideshowContainer
                      tournament={this.props.tournament}
                      slideshow={slideshow}
                      dias={this.props.allDias.filter((dia) => {
                        let showDia = false;
                        if (slideshow.id === "0") {
                          if (
                            dia.slideshow === undefined ||
                            dia.slideshow === "0"
                          ) {
                            showDia = true;
                          }
                        } else {
                          if (dia.slideshow === slideshow.id) {
                            showDia = true;
                          }
                        }
                        return showDia;
                      })}
                      selectSlideshow={this.selectSlideshow}
                      selectedSlideshow={this.props.selectedSlideshow}
                    />
                  </ListItemSecondaryAction>
                </MenuItem>
              ))}
            <MenuItem onClick={this.props.handleAddSlideshow}>
              {"+ " + languages.present.slideshow}
            </MenuItem>
          </Menu>

          <div style={{ paddingBottom: 5, display: "inline-block" }}>
            <Button
              size="small"
              variant="outlined"
              color="default"
              onClick={this.handleMenu}
              style={{ marginRight: 10 }}
              endIcon={<KeyboardArrowDownIcon />}
            >
              {this.props.selectedSlideshow === "0"
                ? this.props.tournament.slideshowName ||
                  languages.present.slideshow + " 1"
                : (
                    this.props.slideshowsByKey[this.props.selectedSlideshow] ||
                    {}
                  ).name ||
                  languages.present.slideshow +
                    " " +
                    (Number(
                      Object.keys(this.props.slideshowsByKey).indexOf(
                        this.props.selectedSlideshow
                      )
                    ) +
                      2)}
            </Button>
            <IconButton
              size="small"
              disabled={!this.props.tournament.liveLink}
              aria-label="Open"
              style={{ marginLeft: "auto" }}
              target="_blank"
              href={
                "https://" +
                (this.props.tournament.isPSD || this.props.tournament.crqpsd
                  ? "tournify.prosoccerdata.com/"
                  : "tournifyapp.com/live/") +
                this.props.tournament.liveLink +
                "/present" +
                (this.props.selectedSlideshow > 0
                  ? "/" +
                    (this.props.slideshows.findIndex(
                      (t) => t.id === this.props.selectedSlideshow
                    ) +
                      2)
                  : "")
              }
            >
              <LaunchIcon />
            </IconButton>
          </div>
        </div>
      </div>
    );
  }
}

export default withTheme(SlideshowsContainer);
